import { createReducer, on } from '@ngrx/store';
import { GeneralDataDTO, UserRole } from '../models';
import { LoadGeneralDataSuccess, SetRole } from './actions';
import { SetLanguage } from '@ca/ca-ng-core';
import { INIT_GENERAL_STATE } from './init-data';

export interface GeneralState {
  role: null | UserRole;
  navigationFilters: GeneralDataDTO['navigationFilters'];
  navigationGroups: GeneralDataDTO['navigationGroups'];
  settings: GeneralDataDTO['settings'];
  translates: GeneralDataDTO['translates'];
  contactLabel: string;
  searchLabel: string;
}

export const initialState: GeneralState = INIT_GENERAL_STATE;

export const reducer = createReducer(
  initialState,
  on(SetRole, (_, { role }) => ({ ..._, role })),
  on(SetLanguage, (_, { language }) => ({
    ..._,
    // language,
    contactLabel: 'Contact',
    searchLabel: language === 'en' ? 'Search' : language === 'fr' ? 'Rechercher' : 'Zoeken',
  })),
  on(LoadGeneralDataSuccess, (_, { language, data }) => ({
    ..._,
    language,
    navigationFilters:
      data.navigationFilters.length > 0 ? data.navigationFilters : _.navigationFilters,
    navigationGroups: data.navigationGroups,
    settings: data.settings,
    translates: data.translates,
  })),
);
